(() => {
  if (window.nciTestimonialsAccessibility) return;
  window.nciTestimonialsAccessibility = true;
  const bases = new WeakMap();
  const names = new WeakMap();
  let scheduled = false;
  const update = () => {
    scheduled = false;
    document.querySelectorAll('.testimonial-card__stars').forEach(stars => {
      const slider = stars.closest('.splide');
      if (!slider) return;
      const tabs = [...slider.querySelectorAll('.splide__pagination [role="tab"]')];
      const panels = [...slider.querySelectorAll('.splide__slide:not(.splide__slide--clone)')];
      if (!tabs.length) {
        panels.forEach(panel => {
          if (panel.getAttribute('aria-labelledby')?.startsWith('nci-tab-')) panel.removeAttribute('aria-labelledby');
        });
        return;
      }
      tabs.forEach(tab => {
        if (!bases.has(tab)) bases.set(tab, tab.getAttribute('aria-controls')?.split(/\s+/)[0]);
        const base = bases.get(tab);
        if (base && !tab.id) tab.id = `nci-tab-${base}`;
      });
      panels.forEach((panel, index) => {
        const tab = [...tabs].reverse().find(candidate => {
          const start = panels.findIndex(p => p.id === bases.get(candidate));
          return start >= 0 && start <= index;
        });
        if (tab?.id && panel.getAttribute('aria-labelledby') !== tab.id) panel.setAttribute('aria-labelledby', tab.id);
      });
      tabs.forEach(tab => {
        const ids = panels.filter(panel => panel.getAttribute('aria-labelledby') === tab.id).map(panel => panel.id).filter(Boolean);
        if (ids.length && tab.getAttribute('aria-controls') !== ids.join(' ')) tab.setAttribute('aria-controls', ids.join(' '));
      });
    });
    document.querySelectorAll('a.jdgm-medal').forEach(medal => {
      const count = medal.querySelector('.jdgm-medal__value')?.textContent.trim();
      const label = medal.getAttribute('aria-label');
      if (!label || !count) return;
      if (!names.has(medal) || names.get(medal).last !== label) names.set(medal, { base: label, last: label });
      const base = names.get(medal).base;
      const next = base.includes(count) ? base : `${base}: ${count}`;
      names.get(medal).last = next;
      if (label !== next) medal.setAttribute('aria-label', next);
    });
  };
  new MutationObserver(() => {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(update);
    }
  }).observe(document.documentElement, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-selected', 'aria-hidden', 'aria-label'] });
  update();
})();
